import React from 'react'
import { PageContent, Video } from 'components/library'
import Dropdown from 'content/components/dropdown/Dropdown'
import './Aspect04.css'

const dropdownOptions = [
  { value: 1, label: 'VOP F8 naar Hangar 5 via Noordelijke trekkerroute' },
  { value: 2, label: 'VOP S96 naar Hangar 73 via Zuidelijke trekkerroute' },
  { value: 3, label: 'VOP B36 naar VOP S72' },
  { value: 4, label: 'Hangar 10 naar VOP D57' },
]

const videosIds = [
  { value: 1, id: 330728139 },
  { value: 2, id: 330729444 },
  { value: 3, id: 330729823 },
  { value: 4, id: 330730146 },
]

class Aspect04 extends React.Component {

  state = {
    value: 1,
  }

  handleChangeVideo = value => this.setState({value})

  render() {
    return (
      <div className="Chapter05-Aspect04">
        <PageContent>
          <div>
            <div style={{ maxWidth: '60rem', margin: '0 auto 4rem' }}>
              <Dropdown
                label="Video"
                options={dropdownOptions}
                value={this.state.value}
                onChange={this.handleChangeVideo} />
            </div>
            <div>
              {videosIds.map((video) => (
                this.state.value === video.value
                  ? <Video key={video.value} vimeoId={video.id}/>
                  : null
              ))}
            </div>
          </div>
        </PageContent>
      </div>
    )
  }
}

export default Aspect04



// WEBPACK FOOTER //
// ./src/content/chapters/05/04/Aspect04.js